<template>
  <!-- faq -->
  <div class="faq-section faq-banner-bg">
    <img src="@/assets/img/bg/bg-21.svg" alt="img" class="d-lg-flex d-none faq-bg2" />
    <img src="@/assets/img/bg/bg-22.svg" alt="img" class="d-lg-flex d-none faq-bg3" />
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="faq-img" data-aos="fade-up">
            <img
              class="img-fluid rounded-5"
              src="@/assets/img/skills/skills-03.jpg"
              alt="img"
              style="height: 730px; width: 893px;"
            />
            <span><i class="isax isax-message-question5"></i></span>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="faq-content">
            <div class="section-header" data-aos="fade-up">
              <span
                class="fw-medium text-secondary text-decoration-underline mb-2 d-inline-block"
                >Pertanyaan Umum</span
              >
              <h2 class="mb-1">Frequently Asked Questions</h2>
              <p>
                Temukan jawaban atas pertanyaan yang paling sering diajukan mengenai platform pelatihan kami.
              </p>
            </div>
            <div
              class="accordion accordion-customicon1 accordions-items-seperate"
              id="accordioncustomicon1Example"
            >
              <div class="accordion-item" data-aos="fade-up">
                <h2 class="accordion-header" id="headingcustomicon1One">
                  <a
                    href="#"
                    class="accordion-button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapsecustomicon1One"
                    aria-expanded="true"
                    aria-controls="collapsecustomicon1One"
                  >
                    Bagaimana cara memulai pelatihan?
                    <i class="isax isax-add fs-20 fw-semibold ms-1"></i>
                  </a>
                </h2>
                <div
                  id="collapsecustomicon1One"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingcustomicon1One"
                  data-bs-parent="#accordioncustomicon1Example"
                >
                  <div class="accordion-body pt-0">
                    <p>
                      Anda dapat langsung memilih modul yang tersedia di katalog pelatihan dan klik tombol "Mulai Belajar". Pastikan Anda sudah login menggunakan akun karyawan Anda.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item" data-aos="fade-up" data-aos-delay="250">
                <h2 class="accordion-header" id="headingcustomicon1Two">
                  <a
                    href="#"
                    class="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapsecustomicon1Two"
                    aria-expanded="false"
                    aria-controls="collapsecustomicon1One"
                  >
                    Apakah saya akan mendapatkan sertifikat?
                    <i class="isax isax-add fs-20 fw-semibold ms-1"></i>
                  </a>
                </h2>
                <div
                  id="collapsecustomicon1Two"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingcustomicon1Two"
                  data-bs-parent="#accordioncustomicon1Example"
                >
                  <div class="accordion-body pt-0">
                    <p>
                      Ya, setiap karyawan yang menyelesaikan modul pelatihan dan lulus ujian evaluasi akan mendapatkan sertifikat penyelesaian internal dari PT Sapta Tunas Teknologi.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item" data-aos="fade-up" data-aos-delay="250">
                <h2 class="accordion-header" id="headingcustomicon1Three">
                  <a
                    href="#"
                    class="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapsecustomicon1Three"
                    aria-expanded="false"
                    aria-controls="collapsecustomicon1One"
                  >
                    Berapa lama batas waktu penyelesaian modul?
                    <i class="isax isax-add fs-20 fw-semibold ms-1"></i>
                  </a>
                </h2>
                <div
                  id="collapsecustomicon1Three"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingcustomicon1Three"
                  data-bs-parent="#accordioncustomicon1Example"
                >
                  <div class="accordion-body pt-0">
                    <p>
                      Waktu penyelesaian bervariasi tergantung pada kompleksitas modul. Namun, platform ini dirancang agar Anda dapat belajar secara mandiri sesuai dengan ketersediaan waktu Anda.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item" data-aos="fade-up" data-aos-delay="250">
                <h2 class="accordion-header" id="headingcustomicon1Four">
                  <a
                    href="#"
                    class="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapsecustomicon1Four"
                    aria-expanded="false"
                    aria-controls="collapsecustomicon1One"
                  >
                    Siapa yang bisa saya hubungi jika ada kendala teknis?
                    <i class="isax isax-add fs-20 fw-semibold ms-1"></i>
                  </a>
                </h2>
                <div
                  id="collapsecustomicon1Four"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingcustomicon1Four"
                  data-bs-parent="#accordioncustomicon1Example"
                >
                  <div class="accordion-body pt-0">
                    <p>
                      Jika Anda mengalami kendala teknis saat mengakses materi atau ujian, silakan hubungi tim IT Support atau departemen HR melalui saluran komunikasi internal perusahaan.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item" data-aos="fade-up" data-aos-delay="250">
                <h2 class="accordion-header" id="headingcustomicon1Five">
                  <a
                    href="#"
                    class="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapsecustomicon1Five"
                    aria-expanded="false"
                    aria-controls="collapsecustomicon1One"
                  >
                    Apa tujuan dari platform Sapta Learning Center?
                    <i class="isax isax-add fs-20 fw-semibold ms-1"></i>
                  </a>
                </h2>
                <div
                  id="collapsecustomicon1Five"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingcustomicon1Five"
                  data-bs-parent="#accordioncustomicon1Example"
                >
                  <div class="accordion-body pt-0">
                    <p>
                      Platform ini bertujuan untuk meningkatkan kompetensi teknis dan profesionalisme seluruh karyawan PT Sapta Tunas Teknologi agar selalu siap menghadapi tantangan di lapangan kerja.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item" data-aos="fade-up" data-aos-delay="250">
                <h2 class="accordion-header" id="headingcustomicon1Six">
                  <a
                    href="#"
                    class="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapsecustomicon1Six"
                    aria-expanded="false"
                    aria-controls="collapsecustomicon1One"
                  >
                    Apakah pelatihan ini wajib bagi semua karyawan?
                    <i class="isax isax-add fs-20 fw-semibold ms-1"></i>
                  </a>
                </h2>
                <div
                  id="collapsecustomicon1Six"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingcustomicon1Six"
                  data-bs-parent="#accordioncustomicon1Example"
                >
                  <div class="accordion-body pt-0">
                    <p>
                      Beberapa modul bersifat wajib sebagai standar kompetensi dasar, sementara modul lainnya bersifat opsional untuk pengembangan diri tambahan. Silakan cek rencana belajar yang ditugaskan kepada Anda.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- faq -->

</template>
